var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { BaseWidget } from "./base-widget";
import { QueriesClientService } from "../services/queries/queries-client.services";
import { SignalClientService } from "../services/basics/signal-client.service";
import { autoinject, transient } from "aurelia-dependency-injection";
import { QueryFilterUriConverter } from "../views/components/converters/queries/query-filter";
import { InitFilterValueConverter } from "../views/components/converters/queries/init-filter";
import * as Enumerable from "linq";
import moment from "moment";
import { DataType } from "../models/queries/queries.models";
var ComparisonWidget = /** @class */ (function (_super) {
    __extends(ComparisonWidget, _super);
    function ComparisonWidget(queriesService, initFilterConverter, signalClientService) {
        var _this = _super.call(this, signalClientService) || this;
        _this.queriesService = queriesService;
        _this.initFilterConverter = initFilterConverter;
        _this.dateFrom = moment().toDate();
        _this.dateTo = moment().toDate();
        _this.chartData = null;
        _this._url = "";
        _this.isLoading = true;
        return _this;
    }
    ComparisonWidget.prototype.onActivate = function (model) {
        this.title = model.title;
        this.type = model.chartType;
        this._url += "/odata/" + (model.entityTypeUri).replace(/\s/g, "");
        var aggregationType = null;
        this._url += "/Genesis.GroupBy(column='" + model.nameProperty.name + "',propertyForAggregation=null,aggregationType='" + aggregationType + "')";
        //get url from query editor
        this._model = model;
        var converterInitialFilters = new QueryFilterUriConverter(this.initFilterConverter, model.queryFilters ? model.queryFilters : [], 0, 1000, Enumerable.from(model.columns).where(function (x) { return x.isSortable; }).toArray());
        this._url = converterInitialFilters.getUri(true, true, this._url);
        this.getData(model);
    };
    ComparisonWidget.prototype.getData = function (model) {
        var _this = this;
        this.isLoading = true;
        this.queriesService.getGroupedDataUri(this._url)
            .then(function (result) {
            _this.chartData = _this.getChartData(model, result);
            _this.isLoading = false;
        });
    };
    ComparisonWidget.prototype.getChartData = function (model, filterResult) {
        var _this = this;
        var result = filterResult[0];
        if (!model.dateProperty)
            return;
        var labels = Enumerable.from(result).select(function (x) {
            var tmp = x;
            if (!tmp.value || tmp.value == null || tmp.value.length == 0)
                return;
            var item = JSON.parse(tmp.value);
            var dateLabels = Enumerable.from(item).select(function (y) {
                var date = moment(y[_this.PascalCasing(model.dateProperty.name)]);
                //if there is and hour property (like in atlantic pricing)
                date = y["Hour"] ? date.add(y["Hour"], "hours") : date;
                if (model.dateProperty.type == DataType.Date)
                    return date.format("DD/MM/YYYY");
                return date.minutes(0).seconds(0).milliseconds(0).format("DD/MM/YYYY HH:mm");
            }).orderBy(function (z) { return z[_this.PascalCasing(model.dateProperty.name)]; }).toArray();
            return dateLabels;
        }).toArray();
        var uniqueLabels = Enumerable.from(labels).selectMany(function (x) { return x; }).toArray().filter(function (v, i, a) { return a.indexOf(v) === i; });
        uniqueLabels = Enumerable.from(uniqueLabels).orderBy(function (x) { return moment(x, "DD/MM/YYYY HH:mm").toDate(); }).toArray();
        var chartData = {
            labels: uniqueLabels,
            chartDataEntries: []
        };
        if (model.selectedDataProperties.length > 0) {
            Object.keys(result).forEach(function (k) {
                if (!result[k] || result[k] == null || result[k].length == 0)
                    return;
                var kValue = JSON.parse(result[k]);
                if (Array.isArray(kValue)) {
                    var list_1 = model.dateProperty ? Enumerable.from(kValue).orderBy(function (x) { return x[_this.PascalCasing(model.dateProperty.name)]; }) : Enumerable.from(kValue);
                    model.selectedDataProperties.forEach(function (prop) {
                        // let data = Enumerable.from(xlist).select(x => x[this.PascalCasing(prop.name)]).toArray();
                        var data = [];
                        if (chartData && chartData.labels) {
                            chartData.labels.forEach(function (z) {
                                var item = list_1.firstOrDefault(function (x) {
                                    var date = moment(x[_this.PascalCasing(model.dateProperty.name)]);
                                    //if there is and hour property (like in atlantic pricing)
                                    date = x["Hour"] ? date.add(x["Hour"], "hours") : date;
                                    if (model.dateProperty.type == DataType.Date)
                                        return date.format("DD/MM/YYYY") == z;
                                    return date.minutes(0).seconds(0).milliseconds(0).format("DD/MM/YYYY HH:mm") == z;
                                });
                                var val = item ? item[_this.PascalCasing(prop.name)] : null;
                                data.push(val);
                            });
                        }
                        else
                            data = Enumerable.from(list_1).select(function (x) { return x[_this.PascalCasing(prop.name)]; }).toArray();
                        var chartEntry = {
                            label: k + " - " + prop.friendlyName,
                            data: data
                        };
                        chartData.chartDataEntries.push(chartEntry);
                    });
                }
            });
        }
        else {
            Object.keys(result).forEach(function (k) {
                if (!result[k] || result[k] == null || result[k].length == 0)
                    return;
                var kValue = JSON.parse(result[k]);
                if (Array.isArray(kValue)) {
                    var list_2 = model.dateProperty ? Enumerable.from(kValue).groupBy(function (x) {
                        if (model.dateProperty.type == DataType.Date)
                            return moment(x[_this.PascalCasing(model.dateProperty.name)]).format("DD/MM/YYYY");
                        return moment(x[_this.PascalCasing(model.dateProperty.name)]).minutes(0).seconds(0).milliseconds(0).format("DD/MM/YYYY HH:mm");
                    }, null, function (key, g) {
                        return {
                            key: key,
                            value: g.count()
                        };
                    }) : Enumerable.from(kValue);
                    var data_1 = [];
                    if (chartData && chartData.labels) {
                        chartData.labels.forEach(function (z) {
                            var item = Enumerable.from(list_2).firstOrDefault(function (x) { return x.key == z; });
                            var val = item ? item.value : null;
                            data_1.push(val);
                        });
                    }
                    else
                        data_1 = Enumerable.from(list_2).select(function (x) { return x.value; }).toArray();
                    var chartEntry = {
                        label: k,
                        data: data_1
                    };
                    chartData.chartDataEntries.push(chartEntry);
                }
            });
        }
        return chartData;
    };
    ComparisonWidget.prototype.reloadData = function () {
        this.getData(this._model);
    };
    ComparisonWidget.prototype.PascalCasing = function (str) {
        return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match) {
            if (+match === 0)
                return "";
            return match.toUpperCase();
        });
    };
    ComparisonWidget = __decorate([
        transient(),
        autoinject(),
        __metadata("design:paramtypes", [QueriesClientService,
            InitFilterValueConverter,
            SignalClientService])
    ], ComparisonWidget);
    return ComparisonWidget;
}(BaseWidget));
export { ComparisonWidget };
